import React, { useState, useEffect, useCallback } from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import {Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { authData } from "../../redux/auth/authSlice";
import Bread from "./Breadcrumbs.module.scss";

const Breadcrumb = ({ Bindex }) => {
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  let userDetails = useSelector(authData);

  const breadcrumb = useCallback(() => {
    let breadcrumb = [];
    if (userDetails.breadcrumb !== undefined) {
      breadcrumb = { ...userDetails.breadcrumb };
    }
    if (Bindex !== undefined) {
      let temp = [];
      for (let i = 0; i <= Bindex; i++) {
        temp.push(breadcrumb[i]);
      }
      if (temp !== undefined) {
        setBreadcrumbs(temp);
      }
    }
  }, [userDetails.breadcrumb, Bindex]);

  useEffect(() => {
    breadcrumb();
  }, [breadcrumb]);


  return (
    <div
      style={{
        marginBottom: 2,
        "& > * + *": {
          marginBottom: 3,
        },
      }}
    >
      {breadcrumbs !== undefined ? (
        <Breadcrumbs separator="›" aria-label="breadcrumb">
          {breadcrumbs?.map((item) => {
            return (
              <Link className={Bread.bread} to={item?.path}>
                {item?.name}
              </Link>
            );
          })}
          ;
        </Breadcrumbs>
      ) : null}
    </div>
  );
};

export default Breadcrumb;
